import { render, staticRenderFns } from "./Captcha.vue?vue&type=template&id=1635624f&"
import script from "./Captcha.js?vue&type=script&lang=js&"
export * from "./Captcha.js?vue&type=script&lang=js&"
import style0 from "./Captcha.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports